import styled from "styled-components";

type ItemContainerProps = {
    isWarning: boolean;
    isPast: boolean;
};

export const ItemContainerStyled = styled.div<ItemContainerProps>`
    color: ${({ isWarning, theme }) =>
        isWarning ? theme.colorWarning : theme.colorMain};
    opacity: ${({ isPast }) => (isPast ? 0.4 : 1)};
`;
